import SectionHeading from "@/components/base/SectionHeading";
import FaqAccordion from "@/components/feature/FaqAccordion";
import CtaBand from "@/components/feature/CtaBand";
import { useSeo } from "@/hooks/useSeo";
import { generalFaqs } from "@/mocks/faq";
import { brand } from "@/mocks/site";
import HomeHero from "./components/HomeHero";
import ValueGrid from "./components/ValueGrid";
import FeaturedTopics from "./components/FeaturedTopics";
import ViralFeatures from "./components/ViralFeatures";
import HeadlineLab from "./components/HeadlineLab";
import WorkflowSteps from "./components/WorkflowSteps";
import Testimonials from "./components/Testimonials";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: brand.name,
    url: "https://sxnxp.cn/",
    description:
      "爆料投稿与选题参考平台，提供高热度选题参考、爆款稿件特征、投稿标题技巧与编辑偏好方向。",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://sxnxp.cn/topics?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: brand.name,
    url: "https://sxnxp.cn/",
    email: brand.email,
    description: brand.intro,
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: generalFaqs.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer },
    })),
  },
];

export default function Home() {
  useSeo({
    title: "爆料投稿 - 高热度选题参考与爆款稿件特征指南",
    description:
      "爆料投稿不知道投什么容易火？爆点投稿社整理高热度征集话题、爆款稿件特征、投稿标题技巧与编辑偏好方向，帮你提高投稿被采用的概率与关注度。",
    keywords: "爆料投稿,高热度选题参考,爆款稿件特征,投稿标题技巧,编辑偏好方向",
    path: "/",
    jsonLd,
  });

  return (
    <>
      <HomeHero />
      <ValueGrid />
      <FeaturedTopics />
      <ViralFeatures />
      <HeadlineLab />
      <WorkflowSteps />
      <Testimonials />

      <section id="faq" className="w-full scroll-mt-20 bg-background-50 px-4 py-16 md:px-6 md:py-24">
        <div className="mx-auto grid w-full grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <SectionHeading
              eyebrow="常见问题"
              title="关于投稿，你最想先问清楚的几件事"
              desc="如果这里没有解答你的疑问，可以带着具体线索直接投稿，编辑会在回复里一并说明。"
            />
            <div className="mt-8 rounded-lg border border-background-200 bg-background-100 p-5">
              <p className="flex items-center gap-2 text-sm font-medium text-foreground-900">
                <i className="ri-mail-send-line text-base leading-none text-primary-500"></i>
                直接联系编辑
              </p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                投稿与合作邮箱：{brand.email}
                <br />
                初审答复：{brand.replyPolicy}
              </p>
            </div>
          </div>
          <div className="lg:col-span-7">
            <FaqAccordion items={generalFaqs} />
          </div>
        </div>
      </section>

      <CtaBand
        title="手里正好有一条线索？现在就可以投出去"
        desc="先浏览选题库找方向，或直接带着材料提交。不需要文采，只需要把事情讲清楚。"
        primaryLabel="我要投稿"
        primaryTo="/submit"
        secondaryLabel="先看看选题库"
        secondaryTo="/topics"
      />
    </>
  );
}